import { IEditVideoState } from './editVideoContext';
import { EditVideoActionTypes, TEditVideoAction } from './editVideoActions';

export const editVideoReducer = (state: IEditVideoState, action: TEditVideoAction): IEditVideoState => {
	switch (action.type) {
		case EditVideoActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
				iconFileId: null,
				videoFileData: { fileId: '', fileHash: null, fileName: null },
			};
		case EditVideoActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditVideoActionTypes.SET_ALL_DATA:
			return {
				...state,
				videoID: action.payload.videoID,
				IDSelectedStudio: action.payload.IDSelectedStudio,
				name: action.payload.name,
				IDSelectedCategory: action.payload.IDSelectedCategory,
				IDsSelectedLanguages: action.payload.IDsSelectedLanguages,
				translations: action.payload.translations,
				iconFilePath: action.payload.iconPath,
				videoFilePath: action.payload.videoPath,
			};
		case EditVideoActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditVideoActionTypes.SET_FILE_ID:
			return {
				...state,
				iconFileId: action.payload.fileId,
			};
		case EditVideoActionTypes.DELETE_PHOTO:
			return {
				...state,
				iconFilePath: null,
				iconFileId: null,
			};
		case EditVideoActionTypes.SET_FETCHED_STUDIOS:
			return {
				...state,
				fetchedStudios: action.payload.studios,
			};
		case EditVideoActionTypes.SET_ID_STUDIO:
			return {
				...state,
				IDSelectedStudio: action.payload.IDStudio,
			};
		case EditVideoActionTypes.REFETCH_STUDIOS:
			return {
				...state,
				needRefetchStudios: action.payload.needRefetch,
			};
		case EditVideoActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditVideoActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.categories,
			};
		case EditVideoActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDCategory,
			};
		case EditVideoActionTypes.CHANGE_FILE_DATA:
			return {
				...state,
				videoFileData: action.payload.fileData,
			};
		case EditVideoActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.languages,
			};
		case EditVideoActionTypes.SET_IDs_LANGUAGES:
			return {
				...state,
				IDsSelectedLanguages: action.payload.IDsLanguages,
			};
		case EditVideoActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.data,
			};
		case EditVideoActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditVideoActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.translationTab,
			};
		case EditVideoActionTypes.SET_TRANSLATION_FIELDS:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case EditVideoActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case EditVideoActionTypes.RESET_FIELDS:
			return {
				...state,
				iconFileId: null,
				fetchedStudios: [],
				IDSelectedStudio: null,
				name: '',
				fetchedCategories: [],
				IDSelectedCategory: null,
				videoFileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				fetchedLanguages: [],
				IDsSelectedLanguages: [],
				dataForSubmit: null,
				translations: [],
			};
		default:
			return state;
	}
};
